import { render, staticRenderFns } from "./AkontaciaButtonGroup.vue?vue&type=template&id=7204e0d9&"
import script from "./AkontaciaButtonGroup.vue?vue&type=script&lang=js&"
export * from "./AkontaciaButtonGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VBtnToggle,VCol,VIcon,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("C:\\azagent\\_work\\3\\s\\master-v3\\Filip.Client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7204e0d9')) {
      api.createRecord('7204e0d9', component.options)
    } else {
      api.reload('7204e0d9', component.options)
    }
    module.hot.accept("./AkontaciaButtonGroup.vue?vue&type=template&id=7204e0d9&", function () {
      api.rerender('7204e0d9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/basic/AkontaciaButtonGroup.vue"
export default component.exports